import { ChangeEvent, memo, ReactNode, useEffect } from "react";
import IMask from "imask";
import { Input, Label, cn } from "@tides/base-library";
interface Props {
  mask: string;
  max_length: number;
  id: string;
  placeholder?: string;
  label?: string;
  card?: string;
  required?: boolean;
  onInput?(event: ChangeEvent<HTMLInputElement>): void;
  onChange?(event: ChangeEvent<HTMLInputElement>): void;
  className?: string;
}

const InputMask = memo(function InputMask({
  mask,
  id,
  card,
  label,
  required,
  onInput,
  onChange,
  className,
}: Props): ReactNode {
  useEffect(() => {
    const htmlElement = document.getElementById(id)!;

    IMask(htmlElement, {
      mask: mask,
    });
  });

  if (card) {
    return (
      <article className={cn("relative h-full w-full", className)}>
        <article className="min-w-sm grid w-full items-center gap-1.5">
          <Label>{label}</Label>
          <Input
            id={id}
            onInput={onInput}
            onChange={onChange}
            required={required}
            className={className}
          />
        </article>

        <img
          width={25}
          height={25}
          src={`/cards/${card}`}
          className="absolute right-3 top-7 text-white"
        />
      </article>
    );
  }

  return (
    <article className={cn("relative grid gap-1.5 h-full w-full", className)}>
      <Label>{label}</Label>
      <Input
        id={id}
        onInput={onInput}
        onChange={onChange}
        required={required}
        className={className}
      />
    </article>
  );
});

export default InputMask;
